<template>
  <div class="about">
    <a-modal
      class="about"
      width="503px"
      height="350px"
      :visible="visible"
      :footer="null"
      @cancel="handleCancel"
    >
      <img class="logo" src="@/assets/img/logo@2x.png" alt="">
      <div class="content">
        <div v-for="(item, inx) in info" :key="inx">
          <img :src="item.icon" alt="">
          <div class="type">{{ item.type }}</div>
          <div>{{ item.content }}</div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import packageJson from '@/../package.json'

export default {
  name: 'About',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      info: [
        {
          icon: require('@/assets/icons/icon_js@2x.png'),
          type: '技术支持:',
          content: '北京格如灵科技有限公司 北京研发中心'
        },
        {
          icon: require('@/assets/icons/icon_dh@2x.png'),
          type: '联系电话:',
          content: '400-888-1126'
        },
        {
          icon: require('@/assets/icons/icon_bb@2x.png'),
          type: '产品版本:',
          content: 'v' + packageJson.version || '1.0.0'
        }
      ]
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
.about {
  /deep/ .ant-modal {
    .ant-modal-content {
      height: 350px;
      background: url(~@/assets/img/bj_gy@2x.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .logo {
    width: 100px;
    height: 40px;
    position: absolute;
    left: 19px;
    top: 12px;
  }
  .content {
    margin: 160px 12px 0;
    font-size: 16px;
    font-weight: bold;
    > div {
      display: flex;
      align-items: center;
      margin-bottom: 22px;
      img {
        width: 19px;
      }
      .type {
        margin: 0 12px;
      }
    }
  }
}
</style>
